<template>
  <div>
    <div :header-url="`${$iriade.apiUrl}/monitoringModules/${mission.module.id}/thumbnail`">
      <IriadeTitle>Je signale une <span class="secondary--text">nouvelle</span> plaie</IriadeTitle>

      <h3 style="color: red" class="my-5">Cette mission est réservée uniquement à la déclaration d'un nouvelle plaie. Si votre plaie actuelle ou vos plaies actuelles ont déjà été déclarées, il vous suffit de répondre à la mission « Comment va votre pied aujourd'hui ? » qui vous est adressée tous les 4 jours.</h3>

      <IriadeContextBlock :block="{config: { text: 'Vous souhaitez signaler une plaie ou plusieurs plaies. Cette mission va vous permettre de poster des photos de votre pied blessé et de les commenter. Répondez au questionnaire associé afin de nous permettre de mieux vous accompagner à chaque étape vers la guérison.'} }"></IriadeContextBlock>
      <IriadeObjectivesBlock :block="{config: { text: 'Recueillir des photos de votre plaie.'} }"></IriadeObjectivesBlock>
      <IriadeInstructionsBlock :block="{config: { text: 'Pour réaliser cette mission, vous devez :\n'+
                                                        '1. Répondre au questionnaire\n'+
                                                        '2. Poster 1 à 3 photos de votre pied blessé\n'+
                                                        '3. Commenter chaque photo afin de faciliter son interprétation\n'+
                                                        '4. VALIDER la mission'} }"></IriadeInstructionsBlock>
      <div>
        Il est important de bien suivre les recommandations de notre fiche santé ci-dessous avant de prendre votre plaie en photo.
      </div>
      <IriadeApplicationMediaBlock :block="{ config: { media: mission.module.config.procedurePhotos}}"></IriadeApplicationMediaBlock>

      <div>
        En cas de doute concernant le type de plaie ou de pansement, consultez les deux fiches santé ci-dessous :
      </div>
      <IriadeApplicationMediaBlock :block="{ config: { media: mission.module.config.typesPansements}}"></IriadeApplicationMediaBlock>
      <IriadeApplicationMediaBlock :block="{ config: { media: mission.module.config.typesPlaies}}"></IriadeApplicationMediaBlock>

      <p style="color: darkorange">
        <v-icon class="mr-1" style="color: darkorange">warning</v-icon>À ce jour, nous avons enregistré <span style="font-weight: bold; color: black">{{mission.module.config.nbPlaies}} plaie{{mission.module.config.nbPlaies > 1 ? 's' : ''}}</span> pour ce patient.
      </p>

      <v-dialog v-model="dialog" persistent
                :fullscreen="$vuetify.breakpoint.smAndDown"
                :transition="$vuetify.breakpoint.smAndDown ? 'dialog-bottom-transition' : 'dialog-transition'"
                :width="$vuetify.breakpoint.mdAndUp ? '60%' : null"
                :persistent="$vuetify.breakpoint.mdAndUp">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-on = "on" v-bind="attrs" class="my-3">Déclarer une nouvelle plaie</v-btn>
        </template>
        <v-card>
          <v-card-title class="headline primary white--text"
                        style="display: flex; justify-content: space-between; position: sticky; top: 0px; z-index: 1;">
            <span style="margin-right: 5%">Déclarer une nouvelle plaie</span>
            <v-icon style="position: absolute; top:10px; right: 10px; color: white;" @click="dialog = false">cancel</v-icon>
          </v-card-title>
          <v-card-text>
            <v-form ref="form"
                    v-model="formValid"
                    class="my-5"
                    :lazy-validation="true">
              <v-radio-group class="mt-0 pt-0" v-model="plaie.cote"
                             :rules="[v => !!v || 'Ce champs est obligatoire']">
                <template v-slot:label>
                  <h3>De quel côté est la plaie ?</h3>
                </template>
                <v-radio label="Droit" value="0"></v-radio>
                <v-radio label="Gauche" value="1"></v-radio>
                <v-radio label="Bilatérale" value="2"></v-radio>
              </v-radio-group>

              <v-radio-group class="mt-0 pt-0" v-model="plaie.localisation"
                             :rules="[v => !!v || 'Ce champs est obligatoire']">
                <template v-slot:label>
                  <h3>Où se situe la plaie plus précisément ?</h3>
                </template>
                <v-radio label="Orteils" value="0"></v-radio>
                <v-radio label="Avant pied" value="1"></v-radio>
                <v-radio label="Médiopied" value="2"></v-radio>
                <v-radio label="Talon" value="3"></v-radio>
              </v-radio-group>

              <v-radio-group class="mt-0 pt-0" v-model="plaie.plaieDAmputation"
                             :rules="[v => !!v || 'Ce champs est obligatoire']">
                <template v-slot:label>
                  <h3>S'agit-il d'une plaie d'amputation ?</h3>
                </template>
                <v-radio label="Oui" value="0"></v-radio>
                <v-radio label="Non" value="1"></v-radio>
              </v-radio-group>

              <v-radio-group class="mt-0 pt-0" v-model="plaie.aspect"
                             :rules="[v => !!v || 'Ce champs est obligatoire']">
                <template v-slot:label>
                  <h3>Quel est l'aspect de la plaie ?</h3>
                </template>
                <v-radio label="Propre" value="0"></v-radio>
                <v-radio label="Fibrineuse" value="1"></v-radio>
                <v-radio label="Nécrotique" value="2"></v-radio>
                <v-radio label="Hémorragique" value="3"></v-radio>
                <v-radio label="Purulente" value="4"></v-radio>
              </v-radio-group>

              <v-radio-group class="mt-0 pt-0" v-model="plaie.aspectPeau"
                             :rules="[v => !!v || 'Ce champs est obligatoire']">
                <template v-slot:label>
                  <h3>Quel est l'aspect de la peau autour de la plaie ?</h3>
                </template>
                <v-radio label="Propre" value="0"></v-radio>
                <v-radio label="Hyperkératosique" value="1"></v-radio>
              </v-radio-group>

              <v-radio-group class="mt-0 pt-0" v-model="plaie.taille"
                             :rules="[v => !!v || 'Ce champs est obligatoire']">
                <template v-slot:label>
                  <h3>Quel est la taille de la plaie ?</h3>
                </template>
                <v-radio label="Moins de 1cm²" value="0"></v-radio>
                <v-radio label="Plus de 1cm²" value="1"></v-radio>
              </v-radio-group>

              <v-radio-group class="mt-0 pt-0" v-model="plaie.atteinteTendonOs"
                             :rules="[v => !!v || 'Ce champs est obligatoire']">
                <template v-slot:label>
                  <h3>Est-ce que un/des tendon/s ou os est/sont atteint/s ?</h3>
                </template>
                <v-radio label="Oui" value="0"></v-radio>
                <v-radio label="Non" value="1"></v-radio>
              </v-radio-group>
              <h3>Prendre une photo de la plaie</h3>
              <div>
                <div v-for="(f, i) in files" style="display: flex; flex-direction: column;">
                  <div style="display: flex; flex-direction: row;">
                    <span class="mr-auto">{{f.name}}</span>
                    <v-icon @click="() => {files.splice(i, 1); commentaires.splice(i, 1)}" style="color: red" class="ml-auto">cancel</v-icon>
                  </div>
                  <span>Commenter cette photo :</span>
                  <div style="display: flex; flex-direction: row;">
                    <v-textarea outlined v-model="commentaires[i]"></v-textarea>
                  </div>
                </div>
              </div>
              <v-file-input multiple
                            label="prendre une photo"
                            filled
                            accept="image/*"
                            v-model="file"
                            @change="addFileToFilesList($event)"
                            prepend-icon="camera_alt"
                            :disabled="files.length >= 3"
                            :rules="[_ => files.length > 0 || 'Il faut au moins une photo pour déclarer une plaie']">
              </v-file-input>
              <div style="display: flex; flex-direction: row; align-items: center">
                <v-checkbox color="red" v-model="plaie.estAlertant"></v-checkbox>
                <h3>: <span v-if="plaie.estAlertant" style="color: red;">Je signale une alerte haute sur cette plaie</span><span style="color: green" v-else>Je ne signale pas une alerte haute sur cette plaie</span></h3>
              </div>
              <h3>Vous pouvez ajouter un commentaire général pour cette plaie</h3>
              <v-textarea outlined v-model="plaie.commentaire"></v-textarea>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <!--span v-show="!formValid" style="color: red; font-style: italic">Pour valider ce formulaire, vous devez avoir rempli tous les champs et avoir ajouté au moins 1 photo (maximum 3 photos).</span-->
            <v-btn :disabled="validForm" @click="addPlaieToList()" color="success" block>Déclarer cette plaie</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-expansion-panels class="my-5" width="100%">
        <v-expansion-panel v-for="(plaie, i) in plaies" :key="i">
          <v-expansion-panel-header>Plaie numéro <span class="primary--text" style="font-weight: bold">{{i + 1}}</span></v-expansion-panel-header>
          <v-expansion-panel-content>
            <div style="display: flex; flex-direction: column; justify-content: space-evenly; width: 70%">
              <div>Côté : <span class="primary--text" style="font-weight: bold">{{plaie.cote === "0" ? 'Droit' : plaie.cote === "1" ? 'Gauche' : 'Bilatérale'}}</span></div>
              <div>Localisation : <span class="primary--text" style="font-weight: bold">{{plaie.localisation === "0" ? 'Orteils' : plaie.localisation === "1" ? 'Avant pied' : plaie.localisation === "2" ? 'Médiopied' : 'Talon'}}</span></div>
              <div>Plaie d'amputation : <span class="primary--text" style="font-weight: bold">{{plaie.plaieDAmputation === "0" ? 'Oui' : 'Non'}}</span></div>
              <div>Aspect : <span class="primary--text" style="font-weight: bold">{{plaie.aspect === "0" ? 'Propre' : plaie.aspect === "1" ? 'Fibrineuse' : plaie.aspect === "2" ? 'Nécrotique' : plaie.aspect === "3" ? 'Hémorragique' : 'Purulente'}}</span></div>
              <div>Aspect de la peau : <span class="primary--text" style="font-weight: bold">{{plaie.aspectPeau === "0" ? 'Propre' : 'Hyperkératosique'}}</span></div>
              <div>Taille : <span class="primary--text" style="font-weight: bold">{{plaie.taille === "0" ? 'Moins de 1cm²' : 'Plus de 1cm²'}}</span></div>
              <div>Tendons / Os atteints : <span class="primary--text" style="font-weight: bold">{{plaie.atteinteTendonOs === "0" ? 'Oui' : 'Non'}}</span></div>
            </div>
            <v-carousel
              hide-delimiters
              v-model="test"
              class="my-5"
              style="width: 200px; height: 356px;">
              <v-carousel-item
                v-for="(img,j) in global.srcs[i]"
                :key="j">
                <v-img
                  :src="img"
                  :aspect-ratio="9/16"
                ></v-img>
              </v-carousel-item>
            </v-carousel>

            <div style="display: flex; flex-direction: column" class="mx-auto">
              <span class="mb-10">Commentaire de cette image :</span>
              <span v-html="global.commentaires[i][test]" style="align-self: center; justify-self: center"></span>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <!--div>
        <div v-show="plaies.length === 0" style="font-size: 18px" class="my-3">
          Pour valider cette mission, vous devez déclarer au moins une nouvelle plaie
        </div>
        <div v-show="plaies.length > 0" v-for="(plaie, i) in plaies" :key="i" style="display: flex; flex-direction: column; margin-bottom: 15px;" class="my-5">
          <div style="display: flex; flex-direction: column; justify-content: space-evenly; width: 70%">
            <div>Plaie numéro <span class="primary--text" style="font-weight: bold">{{i + 1}}</span></div>
            <div>Côté : <span class="primary--text" style="font-weight: bold">{{plaie.cote === "0" ? 'Droit' : plaie.cote === "1" ? 'Gauche' : 'Bilatérale'}}</span></div>
            <div>Localisation : <span class="primary--text" style="font-weight: bold">{{plaie.localisation === "0" ? 'Orteils' : plaie.localisation === "1" ? 'Avant pied' : plaie.localisation === "2" ? 'Médiopied' : 'Talon'}}</span></div>
            <div>Plaie d'amputation : <span class="primary--text" style="font-weight: bold">{{plaie.plaieDAmputation === "0" ? 'Oui' : 'Non'}}</span></div>
            <div>Aspect : <span class="primary--text" style="font-weight: bold">{{plaie.aspect === "0" ? 'Propre' : plaie.aspect === "1" ? 'Fibrineuse' : plaie.aspect === "2" ? 'Nécrotique' : plaie.aspect === "3" ? 'Hémorragique' : 'Purulente'}}</span></div>
            <div>Aspect de la peau : <span class="primary--text" style="font-weight: bold">{{plaie.aspectPeau === "0" ? 'Propre' : 'Hyperkératosique'}}</span></div>
            <div>Taille : <span class="primary--text" style="font-weight: bold">{{plaie.taille === "0" ? 'Moins de 1cm²' : 'Plus de 1cm²'}}</span></div>
            <div>Tendons/Os atteints : <span class="primary--text" style="font-weight: bold">{{plaie.atteinteTendonOs === "0" ? 'Oui' : 'Non'}}</span></div>
          </div>

          <div style="display: flex; flex-direction: row; height: 267px;" class="mt-2">
            <v-carousel
              hide-delimiters
              v-model="test"
              style="width: 150px;">
              <v-carousel-item
                v-for="(img,j) in global.srcs[i]"
                :key="j">
                <v-img
                  :src="img"
                  :aspect-ratio="9/16"
                ></v-img>
              </v-carousel-item>
            </v-carousel>
            <div style="display: flex; flex-direction: column" class="mx-auto">
              <span>Commentaire de cette image :</span>
              <span v-html="global.commentaires[i][test]" style="align-self: center; justify-self: center"></span>
            </div>
          </div>
        </div>
      </div-->

      <FinishMissionButtonBlock class="mt-10"
                                :disabled="loading || plaies.length === 0"
                                @click.native="submit">Valider la mission
      </FinishMissionButtonBlock>
    </div>
  </div>
</template>
<script>
  import api from "api";
  import MissionContainer from "../../../../../../blocks/MissionContainer";
  import IriadeContextBlock from "../../../../../../Iriade/Blocks/IriadeContextBlock/IriadeContextBlock";
  import IriadeObjectivesBlock from "../../../../../../Iriade/Blocks/IriadeObjectivesBlock/IriadeObjectivesBlock";
  import IriadeInstructionsBlock from "../../../../../../Iriade/Blocks/IriadeInstructionsBlock/IriadeInstructionsBlock";
  import FinishMissionButtonBlock from "../../../../../../blocks/FinishMissionButtonBlock";
  import IriadeApplicationMediaBlock from "../../../../../../Iriade/Blocks/IriadeApplicationMediaBlock/IriadeApplicationMediaBlock";

  export default {

    components: {
      IriadeApplicationMediaBlock,
      FinishMissionButtonBlock,
      IriadeInstructionsBlock, IriadeObjectivesBlock, IriadeContextBlock, MissionContainer},

    props: {
      mission: {
        required: true,
        type: Object
      }
    },

    data: () => ({
      test: null,
      dialog: false,
      formValid: true,
      plaie: {
        cote: null,
        localisation: null,
        plaieDAmputation: null,
        aspect: null,
        aspectPeau: null,
        taille: null,
        atteinteTendonOs: null,
        commentaire: '',
        estAlertant: false,
      },
      global: {
        srcs: [],
        files: [],
        commentaires: [],
      },
      file: [],
      files: [],
      commentaires: [],
      plaies: [],
      plaies_ids: [],
      currentPlaieIndex: 0,
      currentFileIndex: 0,

      loading: false,
    }),

    computed: {
      validForm () {
        return this.plaie.cote === null || this.plaie.localisation === null || this.plaie.plaieDAmputation === null || this.plaie.aspect === null || this.plaie.aspectPeau === null || this.plaie.taille === null || this.plaie.atteinteTendonOs === null || this.files.length === 0
      }
    },

    methods: {
      submit() {
        this.loading = true;

        api.post(`biped/plaie/${this.mission.patient_id}/${this.mission.patient_stack_id}`, {'plaies': this.plaies})
          .then(res => {
            this.plaies_ids = res.data;
            this.uploadPhotos();
          })
          .then(_ => {
            this.loading = false;
          });
      },

      uploadPhotos() {
        if (this.currentFileIndex >= this.global.files[this.currentPlaieIndex].length) {
          this.currentFileIndex = 0;
          ++this.currentPlaieIndex;
        }

        if (this.currentPlaieIndex >= this.plaies.length) {
          this.currentPlaieIndex = 0;
          api.post(`missions/${this.mission.id}`, {'plaies': this.plaies})
            .then(_ => {
              this.$mango.snackbar({
                color: 'success',
                text: "Mission validée. Bravo !"
              })
              this.$router.push({name: 'patient@dashboard'})
            })
            .catch(_ => {
              this.$mango.snackbar({
                color: 'error',
                text: "Erreur de validation. Veuillez vérifier le formulaire."
              })
            });
          return;
        }

        let formData = new FormData();

        formData.append('file', this.global.files[this.currentPlaieIndex][this.currentFileIndex]);
        formData.append('commentaire', this.global.commentaires[this.currentPlaieIndex][this.currentFileIndex]);

        console.log(this.currentPlaieIndex + " " + this.currentFileIndex);

        api.post(`biped/photo/${this.plaies_ids[this.currentPlaieIndex]}`, formData, {headers: {'Content-Type': 'multipart/form-data'}})
          .then(_ => {
            ++this.currentFileIndex;
            this.uploadPhotos();
          })
      },

      addFileToFilesList($event) {
        for (let i in $event) {
          if (this.files.length >= 3)
            break;
          let file = $event[i];
          this.files.push(file);
          this.commentaires.push('');
        }
        this.file.splice(0, this.file.length);
      },

      addPlaieToList() {
        this.validate();

        console.log(this.formValid);

        if (!this.formValid) {
          this.$mango.snackbar({
            color: 'error',
            text: "Erreur de validation. Veuillez vérifier le formulaire."
          });
          return;
        }

        let srcs = [];

        for(let i in this.files) {
          let file = this.files[i];
          srcs.push(URL.createObjectURL(file));
        }

        this.global.srcs.push(srcs);
        this.global.files.push(this.files);
        this.global.commentaires.push(this.commentaires);

        this.plaies.push(this.plaie);
        this.dialog = false;
        this.resetValidation();
        this.resetPlaie();
      },

      resetPlaie() {
        this.plaie = {
          cote: null,
          localisation: null,
          plaieDAmputation: null,
          aspect: null,
          aspectPeau: null,
          taille: null,
          atteinteTendonOs: null,
          commentaire: '',
          estAlertant: false,
        };
        this.files = [];
        this.commentaires = [];
      },

      validate () {
        this.$refs.form.validate()
      },

      resetValidation () {
        this.$refs.form.resetValidation()
      },
    },
  }
</script>

<style lang="scss"
       type="text/scss">

  legend.v-label {
    height: 100% !important;
  }
</style>
